import { FunctionComponent, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import useActualUser from "../../../utilities/useActualUser";
import { getSafeRedirect } from "./routingUtils";

interface GuestRouteProps {
  children: ReactNode;
}

const GuestRoute: FunctionComponent<GuestRouteProps> = ({ children }) => {
  const { isLoggedIn, isLoading } = useActualUser();
  const location = useLocation();

  if (isLoading) {
    return null;
  }

  if (isLoggedIn) {
    const target = getSafeRedirect(location.state?.from);
    return <Navigate to={target} replace />;
  }

  return <>{children}</>;
};

export default GuestRoute;
